import React, { useState } from 'react'
import { useAuth } from '../context/AuthContext'
import { useNavigate } from 'react-router-dom'

export default function Register() {
  const { register } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [role, setRole] = useState('guest')
  const [acceptTerms, setAcceptTerms] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const nav = useNavigate()

  // Verificari pentru parola
  const hasMinLength = password.length >= 10
  const hasUpperCase = /[A-Z]/.test(password)
  const hasNumber = /\d/.test(password)
  const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)
  const isValidPassword = hasMinLength && hasUpperCase && hasNumber && hasSpecialChar

  const submit = async (e) => {
    e.preventDefault()
    if (!acceptTerms) {
      alert('Trebuie sa accepti Termenii si Conditiile')
      return
    }
    if (!isValidPassword) {
      alert('Parola nu indeplineste toate cerintele')
      return
    }
    if (password !== confirmPassword) {
      alert('Parola si confirmarea parolei nu coincid')
      return
    }
    try {
      const res = await register(email, password, role)
      // Navigare in functie de rol
      if (res.user.role === 'host') {
        nav('/host')
      } else {
        nav('/guest')
      }
    } catch (err) {
      alert('Inregistrarea a esuat')
    }
  }

  return (
    <div className="register-page">
      <div className="register-container">
        <form className="register-form" onSubmit={submit}>
          <h2>Inregistrare</h2>

          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="exemplu@email.com"
              required
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Parola</label>
            <div className="password-input-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="••••••••••"
                required
                className="form-input"
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? '✕' : '👁'}
              </button>
            </div>

            <div className="password-checks">
              <div className={`password-check ${hasMinLength ? 'valid' : ''}`}>
                <span>●</span> 10+ caractere
              </div>
              <div className={`password-check ${hasUpperCase ? 'valid' : ''}`}>
                <span>●</span> Litera mare
              </div>
              <div className={`password-check ${hasNumber ? 'valid' : ''}`}>
                <span>●</span> Cifra
              </div>
              <div className={`password-check ${hasSpecialChar ? 'valid' : ''}`}>
                <span>●</span> Simbol
              </div>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Confirma parola</label>
            <div className="password-input-wrapper">
              <input
                type={showPassword ? 'text' : 'password'}
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                placeholder="••••••••••"
                required
                className="form-input"
              />
              <button
                type="button"
                className="toggle-password"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? '✕' : '👁'}
              </button>
            </div>
          </div>

          <div className="form-group">
            <label className="form-label">Rol</label>
            <div className="role-buttons">
              <button
                type="button"
                className={`role-button ${role === 'host' ? 'active' : ''}`}
                onClick={() => setRole('host')}
              >
                <span className="role-icon">🏠</span>
                <span>Gazda</span>
              </button>
              <button
                type="button"
                className={`role-button ${role === 'guest' ? 'active' : ''}`}
                onClick={() => setRole('guest')}
              >
                <span className="role-icon">👤</span>
                <span>Oaspete</span>
              </button>
            </div>
          </div>

          <div className="form-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={acceptTerms}
                onChange={e => setAcceptTerms(e.target.checked)}
                className="checkbox-input"
                required
              />
              <span className="checkbox-custom"></span>
              <span className="checkbox-text">
                Accept <a href="/terms_and_privacy.html" target="_blank" rel="noopener noreferrer">termenii si conditiile</a>
              </span>
            </label>
          </div>

          <button type="submit" className="submit-button">
            Inregistreaza-te
          </button>
        </form>
      </div>

      <style>{`
.register-container {
  width: 100%;
  max-width: 420px;
  background: #FFFFFF;
  padding: 1.5rem;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.08);
  box-sizing: border-box;
}

        .register-page {
          min-height: 100vh;
          padding: 1rem;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #F9FAFB;
          box-sizing: border-box;
        }

        .register-form {
          display: flex;
          flex-direction: column;
          gap: 1.5rem;
          width: 100%;
        }

        .register-form h2 {
          text-align: center;
          font-family: 'Sora', sans-serif;
          font-weight: 600;
          font-size: 1.5rem;
          color: #111827;
          margin: 0 0 0.5rem 0;
        }

        .form-group {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
          width: 100%;
        }

        .form-label {
          font-size: 0.875rem;
          font-weight: 500;
          color: #374151;
          font-family: 'Sora', sans-serif;
          display: block;
        }

        .form-input {
          width: 100%;
          padding: 0.75rem 3rem 0.75rem 1rem;
          border: 1px solid #D1D5DB;
          border-radius: 8px;
          font-size: 1rem;
          font-family: 'Sora', sans-serif;
          color: #111827;
          background: #FFFFFF;
          box-sizing: border-box;
        }

        .form-input:focus {
          outline: none;
          border-color: #0C5678;
        }

        .password-input-wrapper {
          position: relative;
          width: 100%;
        }

        .toggle-password {
          position: absolute;
          right: 0.75rem;
          top: 50%;
          transform: translateY(-50%);
          background: none;
          border: none;
          color: #6B7280;
          font-size: 1rem;
          cursor: pointer;
          padding: 0;
          width: 24px;
          height: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .password-checks {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 0.5rem;
          margin-top: 0.5rem;
        }

        .password-check {
          display: flex;
          align-items: center;
          gap: 0.375rem;
          font-size: 0.75rem;
          color: #9CA3AF;
        }

        .password-check.valid {
          color: #059669;
        }

        .password-check.valid span {
          color: #059669;
        }

        .password-check span {
          font-size: 0.5rem;
          color: #9CA3AF;
        }

        .role-buttons {
          display: flex;
          gap: 0.75rem;
          width: 100%;
        }

        .role-button {
          flex: 1;
          padding: 0.75rem;
          border: 1px solid #D1D5DB;
          border-radius: 8px;
          background: #FFFFFF;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 0.375rem;
          cursor: pointer;
          font-family: 'Sora', sans-serif;
          font-size: 0.875rem;
          color: #374151;
        }

        .role-button.active {
          border-color: #0C5678;
          background: #F0F9FF;
          color: #0C5678;
        }

        .role-icon {
          font-size: 1.25rem;
        }

        .checkbox-label {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          cursor: pointer;
          font-size: 0.875rem;
          color: #374151;
          font-family: 'Sora', sans-serif;
        }

        .checkbox-input {
          position: absolute;
          opacity: 0;
          width: 0;
          height: 0;
        }

        .checkbox-custom {
          width: 1.125rem;
          height: 1.125rem;
          border: 1px solid #D1D5DB;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }

        .checkbox-input:checked + .checkbox-custom {
          background: #0C5678;
          border-color: #0C5678;
        }

        .checkbox-input:checked + .checkbox-custom::after {
          content: '✓';
          color: #FFFFFF;
          font-size: 0.75rem;
        }

        .checkbox-text a {
          color: #0C5678;
          text-decoration: none;
          font-weight: 600;
          margin-left: 0.25rem;
        }

        .submit-button {
          width: 100%;
          padding: 0.875rem;
          background: #0C5678;
          color: #FFFFFF;
          font-weight: 600;
          border-radius: 8px;
          border: none;
          cursor: pointer;
          font-family: 'Sora', sans-serif;
          font-size: 1rem;
          margin-top: 0.5rem;
        }

        /* Desktop */
        @media (min-width: 768px) {
  .register-container {
    max-width: 480px;
    padding: 2rem;
  }

  .register-form h2 {
    font-size: 2rem;
  }

  .password-checks {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (min-width: 1280px) {
  .register-container {
    max-width: 520px;
  }
}

@media (max-width: 360px) {
  .register-container {
    padding: 1rem;
  }

  .form-input {
    font-size: 0.95rem;
    padding: 0.7rem 2.5rem 0.7rem 0.9rem;
  }

  .role-button {
    padding: 0.6rem;
    font-size: 0.8rem;
  }
}
      `}</style>
    </div>
  )
}